import * as actions from './actions'

const initState = {
    isLoading: null,
    networkDevice: null
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.START_LOADING:
            return {
                ...state,
                ...{
                    isLoading: true
                }
            }
        case actions.NETWORK_DEVICE_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    networkDevice: action.networkDevice
                }
            }
        default:
            return state
    }
}
